import { MonthsRange, MonthsRangeInput } from '@wrisk/ui-components'
import React, { FunctionComponent, useMemo } from 'react'

import { useWriskTranslation } from '../../../infrastructure/internationalisation'
import { FormInputProps } from '../types'

export const MonthsRangeFormInput: FunctionComponent<FormInputProps<MonthsRange>> = ({
  name,
  value,
  tName,
  tKey,
  onChange,
}) => {
  const { t } = useWriskTranslation()

  const placeholdersTranslated = useMemo(
    () => ({
      from: t<string>(tKey(tName, 'placeholder', 'from')),
      to: t<string>(tKey(tName, 'placeholder', 'to')),
    }),
    [t, tKey, tName],
  )

  return (
    <MonthsRangeInput
      name={name}
      value={value}
      onChange={onChange}
      placeholders={placeholdersTranslated}
      to={t<string>(tKey(tName, 'to'), { defaultValue: null })}
    />
  )
}
